var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWebExSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 71 51"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__a)",
  d: "M16.1 25.528c.8 2.7 1.8 5.4 3.2 7.9.6 1.1 1.2 2.2 2.3 2.9l.6.3c1.6.3 2.5-1 3.1-2.1.8-1.9 1.5-3.8 2.1-5.8.1-.4.2-.7.3-1.1.2-.7.4-1.4.5-2.1l7.1-19c1.5-2 3.4-3.6 5.6-4.7 2.1-1.2 4.5-1.8 7-1.8 3.5 0 7 1.2 9.8 3.4 4.7 3.5 7.4 10.5 7.4 10.5.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3-.6.6-1.4 1.2-2.3 1.5-.8.3-1.8.5-2.7.5-1 0-2-.2-2.9-.7-.9-.4-1.7-1.1-2.4-1.8 0 0 0-.1-.1-.1-.4-.6-.8-1.3-1.1-2-.4-.9-.8-1.7-1.3-2.5-.3-.4-.5-.8-.8-1.2-.2-.4-.5-.7-.9-1-.7-.5-1.5-.7-2.2-.3l-.1.1c-.8.5-1.3 1.6-1.7 2.5-1.1 2.4-1.7 4.8-2.4 7.4l-.3 1.5-3 9.6-4.1 9.1c-1.5 1.9-3.4 3.5-5.6 4.5-2.2 1.1-4.6 1.6-7 1.7-10.1.2-14.8-8.9-14.8-8.9-5.7-9.4-7.4-21.8-7.8-25.8-.2-.9-.2-1.4-.2-1.4 0-1.2.3-2.5 1-3.5.6-1.1 1.5-2 2.6-2.6 1.2-.6 2.4-.8 3.7-.8 1.2 0 2.3.4 3.4 1 .8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6q.6 5.4 2.1 10.5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__b)",
  d: "M16.1 25.528c.8 2.7 1.8 5.4 3.2 7.9.6 1.1 1.2 2.2 2.3 2.9l.6.3c1.6.3 2.5-1 3.1-2.1.8-1.9 1.5-3.8 2.1-5.8.1-.4.2-.7.3-1.1.2-.7.4-1.4.5-2.1l7.1-19c1.5-2 3.4-3.6 5.6-4.7 2.1-1.2 4.5-1.8 7-1.8 3.5 0 7 1.2 9.8 3.4 4.7 3.5 7.4 10.5 7.4 10.5.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3-.6.6-1.4 1.2-2.3 1.5-.8.3-1.8.5-2.7.5-1 0-2-.2-2.9-.7-.9-.4-1.7-1.1-2.4-1.8 0 0 0-.1-.1-.1-.4-.6-.8-1.3-1.1-2-.4-.9-.8-1.7-1.3-2.5-.3-.4-.5-.8-.8-1.2-.2-.4-.5-.7-.9-1-.7-.5-1.5-.7-2.2-.3l-.1.1c-.8.5-1.3 1.6-1.7 2.5-1.1 2.4-1.7 4.8-2.4 7.4l-.3 1.5-3 9.6-4.1 9.1c-1.5 1.9-3.4 3.5-5.6 4.5-2.2 1.1-4.6 1.6-7 1.7-10.1.2-14.8-8.9-14.8-8.9-5.7-9.4-7.4-21.8-7.8-25.8-.2-.9-.2-1.4-.2-1.4 0-1.2.3-2.5 1-3.5.6-1.1 1.5-2 2.6-2.6 1.2-.6 2.4-.8 3.7-.8 1.2 0 2.3.4 3.4 1 .8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6q.6 5.4 2.1 10.5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__c)",
  d: "M16.1 25.528c.8 2.7 1.8 5.4 3.2 7.9.6 1.1 1.2 2.2 2.3 2.9l.6.3c1.6.3 2.5-1 3.1-2.1.8-1.9 1.5-3.8 2.1-5.8.1-.4.2-.7.3-1.1.2-.7.4-1.4.5-2.1l7.1-19c1.5-2 3.4-3.6 5.6-4.7 2.1-1.2 4.5-1.8 7-1.8 3.5 0 7 1.2 9.8 3.4 4.7 3.5 7.4 10.5 7.4 10.5.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3-.6.6-1.4 1.2-2.3 1.5-.8.3-1.8.5-2.7.5-1 0-2-.2-2.9-.7-.9-.4-1.7-1.1-2.4-1.8 0 0 0-.1-.1-.1-.4-.6-.8-1.3-1.1-2-.4-.9-.8-1.7-1.3-2.5-.3-.4-.5-.8-.8-1.2-.2-.4-.5-.7-.9-1-.7-.5-1.5-.7-2.2-.3l-.1.1c-.8.5-1.3 1.6-1.7 2.5-1.1 2.4-1.7 4.8-2.4 7.4l-.3 1.5-3 9.6-4.1 9.1c-1.5 1.9-3.4 3.5-5.6 4.5-2.2 1.1-4.6 1.6-7 1.7-10.1.2-14.8-8.9-14.8-8.9-5.7-9.4-7.4-21.8-7.8-25.8-.2-.9-.2-1.4-.2-1.4 0-1.2.3-2.5 1-3.5.6-1.1 1.5-2 2.6-2.6 1.2-.6 2.4-.8 3.7-.8 1.2 0 2.3.4 3.4 1 .8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6q.6 5.4 2.1 10.5"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__d)",
  d: "M16.1 25.528c.8 2.7 1.8 5.4 3.2 7.9.6 1.1 1.2 2.2 2.3 2.9l.6.3c1.6.3 2.5-1 3.1-2.1.8-1.9 1.5-3.8 2.1-5.8.1-.4.2-.7.3-1.1.2-.7.4-1.4.5-2.1l7.1-19c1.5-2 3.4-3.6 5.6-4.7 2.1-1.2 4.5-1.8 7-1.8 3.5 0 7 1.2 9.8 3.4 4.7 3.5 7.4 10.5 7.4 10.5.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3-.6.6-1.4 1.2-2.3 1.5-.8.3-1.8.5-2.7.5-1 0-2-.2-2.9-.7-.9-.4-1.7-1.1-2.4-1.8 0 0 0-.1-.1-.1-.4-.6-.8-1.3-1.1-2-.4-.9-.8-1.7-1.3-2.5-.3-.4-.5-.8-.8-1.2-.2-.4-.5-.7-.9-1-.7-.5-1.5-.7-2.2-.3l-.1.1c-.8.5-1.3 1.6-1.7 2.5-1.1 2.4-1.7 4.8-2.4 7.4l-.3 1.5-3 9.6-4.1 9.1c-1.5 1.9-3.4 3.5-5.6 4.5-2.2 1.1-4.6 1.6-7 1.7-10.1.2-14.8-8.9-14.8-8.9-5.7-9.4-7.4-21.8-7.8-25.8-.2-.9-.2-1.4-.2-1.4 0-1.2.3-2.5 1-3.5.6-1.1 1.5-2 2.6-2.6 1.2-.6 2.4-.8 3.7-.8 1.2 0 2.3.4 3.4 1 .8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6q.6 5.4 2.1 10.5"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__e)",
  d: "M16.1 25.528c.8 2.7 1.8 5.4 3.2 7.9.6 1.1 1.2 2.2 2.3 2.9l.6.3c1.6.3 2.5-1 3.1-2.1.8-1.9 1.5-3.8 2.1-5.8.1-.4.2-.7.3-1.1.2-.7.4-1.4.5-2.1l7.1-19c1.5-2 3.4-3.6 5.6-4.7 2.1-1.2 4.5-1.8 7-1.8 3.5 0 7 1.2 9.8 3.4 4.7 3.5 7.4 10.5 7.4 10.5.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3-.6.6-1.4 1.2-2.3 1.5-.8.3-1.8.5-2.7.5-1 0-2-.2-2.9-.7-.9-.4-1.7-1.1-2.4-1.8 0 0 0-.1-.1-.1-.4-.6-.8-1.3-1.1-2-.4-.9-.8-1.7-1.3-2.5-.3-.4-.5-.8-.8-1.2-.2-.4-.5-.7-.9-1-.7-.5-1.5-.7-2.2-.3l-.1.1c-.8.5-1.3 1.6-1.7 2.5-1.1 2.4-1.7 4.8-2.4 7.4l-.3 1.5-3 9.6-4.1 9.1c-1.5 1.9-3.4 3.5-5.6 4.5-2.2 1.1-4.6 1.6-7 1.7-10.1.2-14.8-8.9-14.8-8.9-5.7-9.4-7.4-21.8-7.8-25.8-.2-.9-.2-1.4-.2-1.4 0-1.2.3-2.5 1-3.5.6-1.1 1.5-2 2.6-2.6 1.2-.6 2.4-.8 3.7-.8 1.2 0 2.3.4 3.4 1 .8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6q.6 5.4 2.1 10.5"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__f)",
  d: "M16.1 25.528c.8 2.7 1.8 5.4 3.2 7.9.6 1.1 1.2 2.2 2.3 2.9l.6.3c1.6.3 2.5-1 3.1-2.1.8-1.9 1.5-3.8 2.1-5.8.1-.4.2-.7.3-1.1.2-.7.4-1.4.5-2.1l7.1-19c1.5-2 3.4-3.6 5.6-4.7 2.1-1.2 4.5-1.8 7-1.8 3.5 0 7 1.2 9.8 3.4 4.7 3.5 7.4 10.5 7.4 10.5.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3-.6.6-1.4 1.2-2.3 1.5-.8.3-1.8.5-2.7.5-1 0-2-.2-2.9-.7-.9-.4-1.7-1.1-2.4-1.8 0 0 0-.1-.1-.1-.4-.6-.8-1.3-1.1-2-.4-.9-.8-1.7-1.3-2.5-.3-.4-.5-.8-.8-1.2-.2-.4-.5-.7-.9-1-.7-.5-1.5-.7-2.2-.3l-.1.1c-.8.5-1.3 1.6-1.7 2.5-1.1 2.4-1.7 4.8-2.4 7.4l-.3 1.5-3 9.6-4.1 9.1c-1.5 1.9-3.4 3.5-5.6 4.5-2.2 1.1-4.6 1.6-7 1.7-10.1.2-14.8-8.9-14.8-8.9-5.7-9.4-7.4-21.8-7.8-25.8-.2-.9-.2-1.4-.2-1.4 0-1.2.3-2.5 1-3.5.6-1.1 1.5-2 2.6-2.6 1.2-.6 2.4-.8 3.7-.8 1.2 0 2.3.4 3.4 1 .8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6q.6 5.4 2.1 10.5"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__g)",
  d: "M16.1 25.528c.8 2.7 1.8 5.4 3.2 7.9.6 1.1 1.2 2.2 2.3 2.9l.6.3c1.6.3 2.5-1 3.1-2.1.8-1.9 1.5-3.8 2.1-5.8.1-.4.2-.7.3-1.1.2-.7.4-1.4.5-2.1l7.1-19c1.5-2 3.4-3.6 5.6-4.7 2.1-1.2 4.5-1.8 7-1.8 3.5 0 7 1.2 9.8 3.4 4.7 3.5 7.4 10.5 7.4 10.5.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3-.6.6-1.4 1.2-2.3 1.5-.8.3-1.8.5-2.7.5-1 0-2-.2-2.9-.7-.9-.4-1.7-1.1-2.4-1.8 0 0 0-.1-.1-.1-.4-.6-.8-1.3-1.1-2-.4-.9-.8-1.7-1.3-2.5-.3-.4-.5-.8-.8-1.2-.2-.4-.5-.7-.9-1-.7-.5-1.5-.7-2.2-.3l-.1.1c-.8.5-1.3 1.6-1.7 2.5-1.1 2.4-1.7 4.8-2.4 7.4l-.3 1.5-3 9.6-4.1 9.1c-1.5 1.9-3.4 3.5-5.6 4.5-2.2 1.1-4.6 1.6-7 1.7-10.1.2-14.8-8.9-14.8-8.9-5.7-9.4-7.4-21.8-7.8-25.8-.2-.9-.2-1.4-.2-1.4 0-1.2.3-2.5 1-3.5.6-1.1 1.5-2 2.6-2.6 1.2-.6 2.4-.8 3.7-.8 1.2 0 2.3.4 3.4 1 .8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6q.6 5.4 2.1 10.5"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__h)",
  d: "M16.1 25.528c.8 2.7 1.8 5.4 3.2 7.9.6 1.1 1.2 2.2 2.3 2.9l.6.3c1.6.3 2.5-1 3.1-2.1.8-1.9 1.5-3.8 2.1-5.8.1-.4.2-.7.3-1.1.2-.7.4-1.4.5-2.1l7.1-19c1.5-2 3.4-3.6 5.6-4.7 2.1-1.2 4.5-1.8 7-1.8 3.5 0 7 1.2 9.8 3.4 4.7 3.5 7.4 10.5 7.4 10.5.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3-.6.6-1.4 1.2-2.3 1.5-.8.3-1.8.5-2.7.5-1 0-2-.2-2.9-.7-.9-.4-1.7-1.1-2.4-1.8 0 0 0-.1-.1-.1-.4-.6-.8-1.3-1.1-2-.4-.9-.8-1.7-1.3-2.5-.3-.4-.5-.8-.8-1.2-.2-.4-.5-.7-.9-1-.7-.5-1.5-.7-2.2-.3l-.1.1c-.8.5-1.3 1.6-1.7 2.5-1.1 2.4-1.7 4.8-2.4 7.4l-.3 1.5-3 9.6-4.1 9.1c-1.5 1.9-3.4 3.5-5.6 4.5-2.2 1.1-4.6 1.6-7 1.7-10.1.2-14.8-8.9-14.8-8.9-5.7-9.4-7.4-21.8-7.8-25.8-.2-.9-.2-1.4-.2-1.4 0-1.2.3-2.5 1-3.5.6-1.1 1.5-2 2.6-2.6 1.2-.6 2.4-.8 3.7-.8 1.2 0 2.3.4 3.4 1 .8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6q.6 5.4 2.1 10.5"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__i)",
  d: "M16.1 25.528c.8 2.7 1.8 5.4 3.2 7.9.6 1.1 1.2 2.2 2.3 2.9l.6.3c1.6.3 2.5-1 3.1-2.1.8-1.9 1.5-3.8 2.1-5.8.1-.4.2-.7.3-1.1.2-.7.4-1.4.5-2.1l7.1-19c1.5-2 3.4-3.6 5.6-4.7 2.1-1.2 4.5-1.8 7-1.8 3.5 0 7 1.2 9.8 3.4 4.7 3.5 7.4 10.5 7.4 10.5.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3-.6.6-1.4 1.2-2.3 1.5-.8.3-1.8.5-2.7.5-1 0-2-.2-2.9-.7-.9-.4-1.7-1.1-2.4-1.8 0 0 0-.1-.1-.1-.4-.6-.8-1.3-1.1-2-.4-.9-.8-1.7-1.3-2.5-.3-.4-.5-.8-.8-1.2-.2-.4-.5-.7-.9-1-.7-.5-1.5-.7-2.2-.3l-.1.1c-.8.5-1.3 1.6-1.7 2.5-1.1 2.4-1.7 4.8-2.4 7.4l-.3 1.5-3 9.6-4.1 9.1c-1.5 1.9-3.4 3.5-5.6 4.5-2.2 1.1-4.6 1.6-7 1.7-10.1.2-14.8-8.9-14.8-8.9-5.7-9.4-7.4-21.8-7.8-25.8-.2-.9-.2-1.4-.2-1.4 0-1.2.3-2.5 1-3.5.6-1.1 1.5-2 2.6-2.6 1.2-.6 2.4-.8 3.7-.8 1.2 0 2.3.4 3.4 1 .8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6q.6 5.4 2.1 10.5"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__j)",
  d: "M16.1 25.528c.8 2.7 1.8 5.4 3.2 7.9.6 1.1 1.2 2.2 2.3 2.9l.6.3c1.6.3 2.5-1 3.1-2.1.8-1.9 1.5-3.8 2.1-5.8.1-.4.2-.7.3-1.1.2-.7.4-1.4.5-2.1l7.1-19c1.5-2 3.4-3.6 5.6-4.7 2.1-1.2 4.5-1.8 7-1.8 3.5 0 7 1.2 9.8 3.4 4.7 3.5 7.4 10.5 7.4 10.5.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3-.6.6-1.4 1.2-2.3 1.5-.8.3-1.8.5-2.7.5-1 0-2-.2-2.9-.7-.9-.4-1.7-1.1-2.4-1.8 0 0 0-.1-.1-.1-.4-.6-.8-1.3-1.1-2-.4-.9-.8-1.7-1.3-2.5-.3-.4-.5-.8-.8-1.2-.2-.4-.5-.7-.9-1-.7-.5-1.5-.7-2.2-.3l-.1.1c-.8.5-1.3 1.6-1.7 2.5-1.1 2.4-1.7 4.8-2.4 7.4l-.3 1.5-3 9.6-4.1 9.1c-1.5 1.9-3.4 3.5-5.6 4.5-2.2 1.1-4.6 1.6-7 1.7-10.1.2-14.8-8.9-14.8-8.9-5.7-9.4-7.4-21.8-7.8-25.8-.2-.9-.2-1.4-.2-1.4 0-1.2.3-2.5 1-3.5.6-1.1 1.5-2 2.6-2.6 1.2-.6 2.4-.8 3.7-.8 1.2 0 2.3.4 3.4 1 .8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6q.6 5.4 2.1 10.5"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__k)",
  d: "M16.1 25.528c.8 2.7 1.8 5.4 3.2 7.9.6 1.1 1.2 2.2 2.3 2.9l.6.3c1.6.3 2.5-1 3.1-2.1.8-1.9 1.5-3.8 2.1-5.8.1-.4.2-.7.3-1.1.2-.7.4-1.4.5-2.1l7.1-19c1.5-2 3.4-3.6 5.6-4.7 2.1-1.2 4.5-1.8 7-1.8 3.5 0 7 1.2 9.8 3.4 4.7 3.5 7.4 10.5 7.4 10.5.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3-.6.6-1.4 1.2-2.3 1.5-.8.3-1.8.5-2.7.5-1 0-2-.2-2.9-.7-.9-.4-1.7-1.1-2.4-1.8 0 0 0-.1-.1-.1-.4-.6-.8-1.3-1.1-2-.4-.9-.8-1.7-1.3-2.5-.3-.4-.5-.8-.8-1.2-.2-.4-.5-.7-.9-1-.7-.5-1.5-.7-2.2-.3l-.1.1c-.8.5-1.3 1.6-1.7 2.5-1.1 2.4-1.7 4.8-2.4 7.4l-.3 1.5-3 9.6-4.1 9.1c-1.5 1.9-3.4 3.5-5.6 4.5-2.2 1.1-4.6 1.6-7 1.7-10.1.2-14.8-8.9-14.8-8.9-5.7-9.4-7.4-21.8-7.8-25.8-.2-.9-.2-1.4-.2-1.4 0-1.2.3-2.5 1-3.5.6-1.1 1.5-2 2.6-2.6 1.2-.6 2.4-.8 3.7-.8 1.2 0 2.3.4 3.4 1 .8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6q.6 5.4 2.1 10.5"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__l)",
  d: "M16.1 25.528c.8 2.7 1.8 5.4 3.2 7.9.6 1.1 1.2 2.2 2.3 2.9l.6.3c1.6.3 2.5-1 3.1-2.1.8-1.9 1.5-3.8 2.1-5.8.1-.4.2-.7.3-1.1.2-.7.4-1.4.5-2.1l7.1-19c1.5-2 3.4-3.6 5.6-4.7 2.1-1.2 4.5-1.8 7-1.8 3.5 0 7 1.2 9.8 3.4 4.7 3.5 7.4 10.5 7.4 10.5.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3-.6.6-1.4 1.2-2.3 1.5-.8.3-1.8.5-2.7.5-1 0-2-.2-2.9-.7-.9-.4-1.7-1.1-2.4-1.8 0 0 0-.1-.1-.1-.4-.6-.8-1.3-1.1-2-.4-.9-.8-1.7-1.3-2.5-.3-.4-.5-.8-.8-1.2-.2-.4-.5-.7-.9-1-.7-.5-1.5-.7-2.2-.3l-.1.1c-.8.5-1.3 1.6-1.7 2.5-1.1 2.4-1.7 4.8-2.4 7.4l-.3 1.5-3 9.6-4.1 9.1c-1.5 1.9-3.4 3.5-5.6 4.5-2.2 1.1-4.6 1.6-7 1.7-10.1.2-14.8-8.9-14.8-8.9-5.7-9.4-7.4-21.8-7.8-25.8-.2-.9-.2-1.4-.2-1.4 0-1.2.3-2.5 1-3.5.6-1.1 1.5-2 2.6-2.6 1.2-.6 2.4-.8 3.7-.8 1.2 0 2.3.4 3.4 1 .8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6q.6 5.4 2.1 10.5"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__m)",
  d: "M16.1 25.528c.8 2.7 1.8 5.4 3.2 7.9.6 1.1 1.2 2.2 2.3 2.9l.6.3c1.6.3 2.5-1 3.1-2.1.8-1.9 1.5-3.8 2.1-5.8.1-.4.2-.7.3-1.1.2-.7.4-1.4.5-2.1l7.1-19c1.5-2 3.4-3.6 5.6-4.7 2.1-1.2 4.5-1.8 7-1.8 3.5 0 7 1.2 9.8 3.4 4.7 3.5 7.4 10.5 7.4 10.5.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3-.6.6-1.4 1.2-2.3 1.5-.8.3-1.8.5-2.7.5-1 0-2-.2-2.9-.7-.9-.4-1.7-1.1-2.4-1.8 0 0 0-.1-.1-.1-.4-.6-.8-1.3-1.1-2-.4-.9-.8-1.7-1.3-2.5-.3-.4-.5-.8-.8-1.2-.2-.4-.5-.7-.9-1-.7-.5-1.5-.7-2.2-.3l-.1.1c-.8.5-1.3 1.6-1.7 2.5-1.1 2.4-1.7 4.8-2.4 7.4l-.3 1.5-3 9.6-4.1 9.1c-1.5 1.9-3.4 3.5-5.6 4.5-2.2 1.1-4.6 1.6-7 1.7-10.1.2-14.8-8.9-14.8-8.9-5.7-9.4-7.4-21.8-7.8-25.8-.2-.9-.2-1.4-.2-1.4 0-1.2.3-2.5 1-3.5.6-1.1 1.5-2 2.6-2.6 1.2-.6 2.4-.8 3.7-.8 1.2 0 2.3.4 3.4 1 .8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6q.6 5.4 2.1 10.5"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__n)",
  d: "M16.1 25.528c.8 2.7 1.8 5.4 3.2 7.9.6 1.1 1.2 2.2 2.3 2.9l.6.3c1.6.3 2.5-1 3.1-2.1.8-1.9 1.5-3.8 2.1-5.8.1-.4.2-.7.3-1.1.2-.7.4-1.4.5-2.1l7.1-19c1.5-2 3.4-3.6 5.6-4.7 2.1-1.2 4.5-1.8 7-1.8 3.5 0 7 1.2 9.8 3.4 4.7 3.5 7.4 10.5 7.4 10.5.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3-.6.6-1.4 1.2-2.3 1.5-.8.3-1.8.5-2.7.5-1 0-2-.2-2.9-.7-.9-.4-1.7-1.1-2.4-1.8 0 0 0-.1-.1-.1-.4-.6-.8-1.3-1.1-2-.4-.9-.8-1.7-1.3-2.5-.3-.4-.5-.8-.8-1.2-.2-.4-.5-.7-.9-1-.7-.5-1.5-.7-2.2-.3l-.1.1c-.8.5-1.3 1.6-1.7 2.5-1.1 2.4-1.7 4.8-2.4 7.4l-.3 1.5-3 9.6-4.1 9.1c-1.5 1.9-3.4 3.5-5.6 4.5-2.2 1.1-4.6 1.6-7 1.7-10.1.2-14.8-8.9-14.8-8.9-5.7-9.4-7.4-21.8-7.8-25.8-.2-.9-.2-1.4-.2-1.4 0-1.2.3-2.5 1-3.5.6-1.1 1.5-2 2.6-2.6 1.2-.6 2.4-.8 3.7-.8 1.2 0 2.3.4 3.4 1 .8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6q.6 5.4 2.1 10.5"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__o)",
  d: "M16.1 25.528c.8 2.7 1.8 5.4 3.2 7.9.6 1.1 1.2 2.2 2.3 2.9l.6.3c1.6.3 2.5-1 3.1-2.1.8-1.9 1.5-3.8 2.1-5.8.1-.4.2-.7.3-1.1.2-.7.4-1.4.5-2.1l7.1-19c1.5-2 3.4-3.6 5.6-4.7 2.1-1.2 4.5-1.8 7-1.8 3.5 0 7 1.2 9.8 3.4 4.7 3.5 7.4 10.5 7.4 10.5.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3-.6.6-1.4 1.2-2.3 1.5-.8.3-1.8.5-2.7.5-1 0-2-.2-2.9-.7-.9-.4-1.7-1.1-2.4-1.8 0 0 0-.1-.1-.1-.4-.6-.8-1.3-1.1-2-.4-.9-.8-1.7-1.3-2.5-.3-.4-.5-.8-.8-1.2-.2-.4-.5-.7-.9-1-.7-.5-1.5-.7-2.2-.3l-.1.1c-.8.5-1.3 1.6-1.7 2.5-1.1 2.4-1.7 4.8-2.4 7.4l-.3 1.5-3 9.6-4.1 9.1c-1.5 1.9-3.4 3.5-5.6 4.5-2.2 1.1-4.6 1.6-7 1.7-10.1.2-14.8-8.9-14.8-8.9-5.7-9.4-7.4-21.8-7.8-25.8-.2-.9-.2-1.4-.2-1.4 0-1.2.3-2.5 1-3.5.6-1.1 1.5-2 2.6-2.6 1.2-.6 2.4-.8 3.7-.8 1.2 0 2.3.4 3.4 1 .8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6q.6 5.4 2.1 10.5"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__p)",
  d: "M16.1 25.528c.8 2.7 1.8 5.4 3.2 7.9.6 1.1 1.2 2.2 2.3 2.9l.6.3c1.6.3 2.5-1 3.1-2.1.8-1.9 1.5-3.8 2.1-5.8.1-.4.2-.7.3-1.1.2-.7.4-1.4.5-2.1l7.1-19c1.5-2 3.4-3.6 5.6-4.7 2.1-1.2 4.5-1.8 7-1.8 3.5 0 7 1.2 9.8 3.4 4.7 3.5 7.4 10.5 7.4 10.5.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3-.6.6-1.4 1.2-2.3 1.5-.8.3-1.8.5-2.7.5-1 0-2-.2-2.9-.7-.9-.4-1.7-1.1-2.4-1.8 0 0 0-.1-.1-.1-.4-.6-.8-1.3-1.1-2-.4-.9-.8-1.7-1.3-2.5-.3-.4-.5-.8-.8-1.2-.2-.4-.5-.7-.9-1-.7-.5-1.5-.7-2.2-.3l-.1.1c-.8.5-1.3 1.6-1.7 2.5-1.1 2.4-1.7 4.8-2.4 7.4l-.3 1.5-3 9.6-4.1 9.1c-1.5 1.9-3.4 3.5-5.6 4.5-2.2 1.1-4.6 1.6-7 1.7-10.1.2-14.8-8.9-14.8-8.9-5.7-9.4-7.4-21.8-7.8-25.8-.2-.9-.2-1.4-.2-1.4 0-1.2.3-2.5 1-3.5.6-1.1 1.5-2 2.6-2.6 1.2-.6 2.4-.8 3.7-.8 1.2 0 2.3.4 3.4 1 .8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6q.6 5.4 2.1 10.5"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__q)",
  d: "M16.1 25.528c.8 2.7 1.8 5.4 3.2 7.9.6 1.1 1.2 2.2 2.3 2.9l.6.3c1.6.3 2.5-1 3.1-2.1.8-1.9 1.5-3.8 2.1-5.8.1-.4.2-.7.3-1.1.2-.7.4-1.4.5-2.1l7.1-19c1.5-2 3.4-3.6 5.6-4.7 2.1-1.2 4.5-1.8 7-1.8 3.5 0 7 1.2 9.8 3.4 4.7 3.5 7.4 10.5 7.4 10.5.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3-.6.6-1.4 1.2-2.3 1.5-.8.3-1.8.5-2.7.5-1 0-2-.2-2.9-.7-.9-.4-1.7-1.1-2.4-1.8 0 0 0-.1-.1-.1-.4-.6-.8-1.3-1.1-2-.4-.9-.8-1.7-1.3-2.5-.3-.4-.5-.8-.8-1.2-.2-.4-.5-.7-.9-1-.7-.5-1.5-.7-2.2-.3l-.1.1c-.8.5-1.3 1.6-1.7 2.5-1.1 2.4-1.7 4.8-2.4 7.4l-.3 1.5-3 9.6-4.1 9.1c-1.5 1.9-3.4 3.5-5.6 4.5-2.2 1.1-4.6 1.6-7 1.7-10.1.2-14.8-8.9-14.8-8.9-5.7-9.4-7.4-21.8-7.8-25.8-.2-.9-.2-1.4-.2-1.4 0-1.2.3-2.5 1-3.5.6-1.1 1.5-2 2.6-2.6 1.2-.6 2.4-.8 3.7-.8 1.2 0 2.3.4 3.4 1 .8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6q.6 5.4 2.1 10.5"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__r)",
  d: "M16.1 25.528c.8 2.7 1.8 5.4 3.2 7.9.6 1.1 1.2 2.2 2.3 2.9l.6.3c1.6.3 2.5-1 3.1-2.1.8-1.9 1.5-3.8 2.1-5.8.1-.4.2-.7.3-1.1.2-.7.4-1.4.5-2.1l7.1-19c1.5-2 3.4-3.6 5.6-4.7 2.1-1.2 4.5-1.8 7-1.8 3.5 0 7 1.2 9.8 3.4 4.7 3.5 7.4 10.5 7.4 10.5.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3-.6.6-1.4 1.2-2.3 1.5-.8.3-1.8.5-2.7.5-1 0-2-.2-2.9-.7-.9-.4-1.7-1.1-2.4-1.8 0 0 0-.1-.1-.1-.4-.6-.8-1.3-1.1-2-.4-.9-.8-1.7-1.3-2.5-.3-.4-.5-.8-.8-1.2-.2-.4-.5-.7-.9-1-.7-.5-1.5-.7-2.2-.3l-.1.1c-.8.5-1.3 1.6-1.7 2.5-1.1 2.4-1.7 4.8-2.4 7.4l-.3 1.5-3 9.6-4.1 9.1c-1.5 1.9-3.4 3.5-5.6 4.5-2.2 1.1-4.6 1.6-7 1.7-10.1.2-14.8-8.9-14.8-8.9-5.7-9.4-7.4-21.8-7.8-25.8-.2-.9-.2-1.4-.2-1.4 0-1.2.3-2.5 1-3.5.6-1.1 1.5-2 2.6-2.6 1.2-.6 2.4-.8 3.7-.8 1.2 0 2.3.4 3.4 1 .8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6q.6 5.4 2.1 10.5"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__s)",
  d: "M16.1 25.528c.8 2.7 1.8 5.4 3.2 7.9.6 1.1 1.2 2.2 2.3 2.9l.6.3c1.6.3 2.5-1 3.1-2.1.8-1.9 1.5-3.8 2.1-5.8.1-.4.2-.7.3-1.1.2-.7.4-1.4.5-2.1l7.1-19c1.5-2 3.4-3.6 5.6-4.7 2.1-1.2 4.5-1.8 7-1.8 3.5 0 7 1.2 9.8 3.4 4.7 3.5 7.4 10.5 7.4 10.5.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3-.6.6-1.4 1.2-2.3 1.5-.8.3-1.8.5-2.7.5-1 0-2-.2-2.9-.7-.9-.4-1.7-1.1-2.4-1.8 0 0 0-.1-.1-.1-.4-.6-.8-1.3-1.1-2-.4-.9-.8-1.7-1.3-2.5-.3-.4-.5-.8-.8-1.2-.2-.4-.5-.7-.9-1-.7-.5-1.5-.7-2.2-.3l-.1.1c-.8.5-1.3 1.6-1.7 2.5-1.1 2.4-1.7 4.8-2.4 7.4l-.3 1.5-3 9.6-4.1 9.1c-1.5 1.9-3.4 3.5-5.6 4.5-2.2 1.1-4.6 1.6-7 1.7-10.1.2-14.8-8.9-14.8-8.9-5.7-9.4-7.4-21.8-7.8-25.8-.2-.9-.2-1.4-.2-1.4 0-1.2.3-2.5 1-3.5.6-1.1 1.5-2 2.6-2.6 1.2-.6 2.4-.8 3.7-.8 1.2 0 2.3.4 3.4 1 .8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6q.6 5.4 2.1 10.5"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__t)",
  d: "M16.1 25.528c.8 2.7 1.8 5.4 3.2 7.9.6 1.1 1.2 2.2 2.3 2.9l.6.3c1.6.3 2.5-1 3.1-2.1.8-1.9 1.5-3.8 2.1-5.8.1-.4.2-.7.3-1.1.2-.7.4-1.4.5-2.1l7.1-19c1.5-2 3.4-3.6 5.6-4.7 2.1-1.2 4.5-1.8 7-1.8 3.5 0 7 1.2 9.8 3.4 4.7 3.5 7.4 10.5 7.4 10.5.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3-.6.6-1.4 1.2-2.3 1.5-.8.3-1.8.5-2.7.5-1 0-2-.2-2.9-.7-.9-.4-1.7-1.1-2.4-1.8 0 0 0-.1-.1-.1-.4-.6-.8-1.3-1.1-2-.4-.9-.8-1.7-1.3-2.5-.3-.4-.5-.8-.8-1.2-.2-.4-.5-.7-.9-1-.7-.5-1.5-.7-2.2-.3l-.1.1c-.8.5-1.3 1.6-1.7 2.5-1.1 2.4-1.7 4.8-2.4 7.4l-.3 1.5-3 9.6-4.1 9.1c-1.5 1.9-3.4 3.5-5.6 4.5-2.2 1.1-4.6 1.6-7 1.7-10.1.2-14.8-8.9-14.8-8.9-5.7-9.4-7.4-21.8-7.8-25.8-.2-.9-.2-1.4-.2-1.4 0-1.2.3-2.5 1-3.5.6-1.1 1.5-2 2.6-2.6 1.2-.6 2.4-.8 3.7-.8 1.2 0 2.3.4 3.4 1 .8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6q.6 5.4 2.1 10.5"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__u)",
  d: "m30.7 18.428 4.5-12.1c1.5-2 3.4-3.6 5.6-4.7 2.2-1 4.6-1.6 7.1-1.6 3.5 0 7 1.2 9.8 3.4 4.7 3.5 7.4 10.5 7.4 10.5.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3-.6.6-1.4 1.2-2.3 1.5-.8.3-1.8.5-2.7.5-1 0-2-.2-2.9-.7-.9-.4-1.7-1.1-2.4-1.8 0 0 0-.1-.1-.1-.4-.6-.8-1.3-1.1-2-.4-.9-.8-1.7-1.3-2.5-.3-.4-.5-.8-.8-1.2-.2-.4-.5-.7-.9-1-.7-.5-1.5-.7-2.2-.3l-.1.1c-.8.5-1.3 1.6-1.7 2.5-1.1 2.4-1.7 4.8-2.4 7.4l-.3 1.5-3 9.6z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__v)",
  d: "M63.5 7.628c-.6 0-1.2.1-1.7.2q1.95 2.85 3.3 6c.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3s-1.4 1.2-2.3 1.5c-.8.3-1.8.5-2.7.5-1.2 0-2.5-.3-3.5-1l-.7 2.7c-1.3 4.4-2.2 6-2.2 6-.5 1.2-1.1 2.3-1.8 3.4-.5.7-1.1 1.4-1.9 1.7-.3.1-.6.1-.9.1q-.45 0-.9-.3c-.5-.4-1-1-1.3-1.6-.4-.7-.7-1.4-1-2.1-.6-1.5-1.6-5.2-1.6-5.2l-1-3.9-1-3.9-.7-2.6c-1.8-6.7-4.4-10-4.4-10-2-2.9-4.9-5-8.2-6.2-3.8-1.4-7.8-.6-7.8-.6-6.3 1.2-9.6 5.5-11 7.6.7.2 1.3.4 1.9.8.8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6.4 3.5 1.1 6.9 2 10.3 2.1-7.1 4.7-10.4 4.7-10.4.3-.4.6-.7 1-.9.2-.1.4-.2.7-.2.4 0 .9.1 1.2.3.1 0 .1.1.2.1.3.3.6.6.9 1 .5 1 1 1.9 1.4 3 .8 2.2 1.5 5 1.5 5l2 8c1.5 5.5 2.7 8.1 2.7 8.1 3.1 7.1 7.8 9.1 7.8 9.1 2.3 1.2 4.9 1.9 7.5 2 2.5.1 5-.4 7.2-1.5 2.4-1.2 4.6-3 6.3-5.1 1.1-1.3 2.8-4.5 2.8-4.5 1.9-3.7 3.3-7.6 4.3-11.6.7-2.5 1.2-5 1.6-7.6.2-1.3.4-2.5.5-3.8.2-1.2.2-2.4-.1-3.6-.1-.2-.1-.4-.2-.6-.6-1.5-1.7-2.7-3.1-3.5-1-.7-2.2-1-3.4-1"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__w)",
  d: "M63.5 7.628c-.6 0-1.2.1-1.7.2q1.95 2.85 3.3 6c.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3s-1.4 1.2-2.3 1.5c-.8.3-1.8.5-2.7.5-1.2 0-2.5-.3-3.5-1l-.7 2.7c-1.3 4.4-2.2 6-2.2 6-.5 1.2-1.1 2.3-1.8 3.4-.5.7-1.1 1.4-1.9 1.7-.3.1-.6.1-.9.1q-.45 0-.9-.3c-.5-.4-1-1-1.3-1.6-.4-.7-.7-1.4-1-2.1-.6-1.5-1.6-5.2-1.6-5.2l-1-3.9-1-3.9-.7-2.6c-1.8-6.7-4.4-10-4.4-10-2-2.9-4.9-5-8.2-6.2-3.8-1.4-7.8-.6-7.8-.6-6.3 1.2-9.6 5.5-11 7.6.7.2 1.3.4 1.9.8.8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6.4 3.5 1.1 6.9 2 10.3 2.1-7.1 4.7-10.4 4.7-10.4.3-.4.6-.7 1-.9.2-.1.4-.2.7-.2.4 0 .9.1 1.2.3.1 0 .1.1.2.1.3.3.6.6.9 1 .5 1 1 1.9 1.4 3 .8 2.2 1.5 5 1.5 5l2 8c1.5 5.5 2.7 8.1 2.7 8.1 3.1 7.1 7.8 9.1 7.8 9.1 2.3 1.2 4.9 1.9 7.5 2 2.5.1 5-.4 7.2-1.5 2.4-1.2 4.6-3 6.3-5.1 1.1-1.3 2.8-4.5 2.8-4.5 1.9-3.7 3.3-7.6 4.3-11.6.7-2.5 1.2-5 1.6-7.6.2-1.3.4-2.5.5-3.8.2-1.2.2-2.4-.1-3.6-.1-.2-.1-.4-.2-.6-.6-1.5-1.7-2.7-3.1-3.5-1-.7-2.2-1-3.4-1"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__x)",
  d: "M63.5 7.628c-.6 0-1.2.1-1.7.2q1.95 2.85 3.3 6c.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3s-1.4 1.2-2.3 1.5c-.8.3-1.8.5-2.7.5-1.2 0-2.5-.3-3.5-1l-.7 2.7c-1.3 4.4-2.2 6-2.2 6-.5 1.2-1.1 2.3-1.8 3.4-.5.7-1.1 1.4-1.9 1.7-.3.1-.6.1-.9.1q-.45 0-.9-.3c-.5-.4-1-1-1.3-1.6-.4-.7-.7-1.4-1-2.1-.6-1.5-1.6-5.2-1.6-5.2l-1-3.9-1-3.9-.7-2.6c-1.8-6.7-4.4-10-4.4-10-2-2.9-4.9-5-8.2-6.2-3.8-1.4-7.8-.6-7.8-.6-6.3 1.2-9.6 5.5-11 7.6.7.2 1.3.4 1.9.8.8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6.4 3.5 1.1 6.9 2 10.3 2.1-7.1 4.7-10.4 4.7-10.4.3-.4.6-.7 1-.9.2-.1.4-.2.7-.2.4 0 .9.1 1.2.3.1 0 .1.1.2.1.3.3.6.6.9 1 .5 1 1 1.9 1.4 3 .8 2.2 1.5 5 1.5 5l2 8c1.5 5.5 2.7 8.1 2.7 8.1 3.1 7.1 7.8 9.1 7.8 9.1 2.3 1.2 4.9 1.9 7.5 2 2.5.1 5-.4 7.2-1.5 2.4-1.2 4.6-3 6.3-5.1 1.1-1.3 2.8-4.5 2.8-4.5 1.9-3.7 3.3-7.6 4.3-11.6.7-2.5 1.2-5 1.6-7.6.2-1.3.4-2.5.5-3.8.2-1.2.2-2.4-.1-3.6-.1-.2-.1-.4-.2-.6-.6-1.5-1.7-2.7-3.1-3.5-1-.7-2.2-1-3.4-1"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__y)",
  d: "M63.5 7.628c-.6 0-1.2.1-1.7.2q1.95 2.85 3.3 6c.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3s-1.4 1.2-2.3 1.5c-.8.3-1.8.5-2.7.5-1.2 0-2.5-.3-3.5-1l-.7 2.7c-1.3 4.4-2.2 6-2.2 6-.5 1.2-1.1 2.3-1.8 3.4-.5.7-1.1 1.4-1.9 1.7-.3.1-.6.1-.9.1q-.45 0-.9-.3c-.5-.4-1-1-1.3-1.6-.4-.7-.7-1.4-1-2.1-.6-1.5-1.6-5.2-1.6-5.2l-1-3.9-1-3.9-.7-2.6c-1.8-6.7-4.4-10-4.4-10-2-2.9-4.9-5-8.2-6.2-3.8-1.4-7.8-.6-7.8-.6-6.3 1.2-9.6 5.5-11 7.6.7.2 1.3.4 1.9.8.8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6.4 3.5 1.1 6.9 2 10.3 2.1-7.1 4.7-10.4 4.7-10.4.3-.4.6-.7 1-.9.2-.1.4-.2.7-.2.4 0 .9.1 1.2.3.1 0 .1.1.2.1.3.3.6.6.9 1 .5 1 1 1.9 1.4 3 .8 2.2 1.5 5 1.5 5l2 8c1.5 5.5 2.7 8.1 2.7 8.1 3.1 7.1 7.8 9.1 7.8 9.1 2.3 1.2 4.9 1.9 7.5 2 2.5.1 5-.4 7.2-1.5 2.4-1.2 4.6-3 6.3-5.1 1.1-1.3 2.8-4.5 2.8-4.5 1.9-3.7 3.3-7.6 4.3-11.6.7-2.5 1.2-5 1.6-7.6.2-1.3.4-2.5.5-3.8.2-1.2.2-2.4-.1-3.6-.1-.2-.1-.4-.2-.6-.6-1.5-1.7-2.7-3.1-3.5-1-.7-2.2-1-3.4-1"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__z)",
  d: "M63.5 7.628c-.6 0-1.2.1-1.7.2q1.95 2.85 3.3 6c.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3s-1.4 1.2-2.3 1.5c-.8.3-1.8.5-2.7.5-1.2 0-2.5-.3-3.5-1l-.7 2.7c-1.3 4.4-2.2 6-2.2 6-.5 1.2-1.1 2.3-1.8 3.4-.5.7-1.1 1.4-1.9 1.7-.3.1-.6.1-.9.1q-.45 0-.9-.3c-.5-.4-1-1-1.3-1.6-.4-.7-.7-1.4-1-2.1-.6-1.5-1.6-5.2-1.6-5.2l-1-3.9-1-3.9-.7-2.6c-1.8-6.7-4.4-10-4.4-10-2-2.9-4.9-5-8.2-6.2-3.8-1.4-7.8-.6-7.8-.6-6.3 1.2-9.6 5.5-11 7.6.7.2 1.3.4 1.9.8.8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6.4 3.5 1.1 6.9 2 10.3 2.1-7.1 4.7-10.4 4.7-10.4.3-.4.6-.7 1-.9.2-.1.4-.2.7-.2.4 0 .9.1 1.2.3.1 0 .1.1.2.1.3.3.6.6.9 1 .5 1 1 1.9 1.4 3 .8 2.2 1.5 5 1.5 5l2 8c1.5 5.5 2.7 8.1 2.7 8.1 3.1 7.1 7.8 9.1 7.8 9.1 2.3 1.2 4.9 1.9 7.5 2 2.5.1 5-.4 7.2-1.5 2.4-1.2 4.6-3 6.3-5.1 1.1-1.3 2.8-4.5 2.8-4.5 1.9-3.7 3.3-7.6 4.3-11.6.7-2.5 1.2-5 1.6-7.6.2-1.3.4-2.5.5-3.8.2-1.2.2-2.4-.1-3.6-.1-.2-.1-.4-.2-.6-.6-1.5-1.7-2.7-3.1-3.5-1-.7-2.2-1-3.4-1"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__A)",
  d: "M63.5 7.628c-.6 0-1.2.1-1.7.2q1.95 2.85 3.3 6c.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3s-1.4 1.2-2.3 1.5c-.8.3-1.8.5-2.7.5-1.2 0-2.5-.3-3.5-1l-.7 2.7c-1.3 4.4-2.2 6-2.2 6-.5 1.2-1.1 2.3-1.8 3.4-.5.7-1.1 1.4-1.9 1.7-.3.1-.6.1-.9.1q-.45 0-.9-.3c-.5-.4-1-1-1.3-1.6-.4-.7-.7-1.4-1-2.1-.6-1.5-1.6-5.2-1.6-5.2l-1-3.9-1-3.9-.7-2.6c-1.8-6.7-4.4-10-4.4-10-2-2.9-4.9-5-8.2-6.2-3.8-1.4-7.8-.6-7.8-.6-6.3 1.2-9.6 5.5-11 7.6.7.2 1.3.4 1.9.8.8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6.4 3.5 1.1 6.9 2 10.3 2.1-7.1 4.7-10.4 4.7-10.4.3-.4.6-.7 1-.9.2-.1.4-.2.7-.2.4 0 .9.1 1.2.3.1 0 .1.1.2.1.3.3.6.6.9 1 .5 1 1 1.9 1.4 3 .8 2.2 1.5 5 1.5 5l2 8c1.5 5.5 2.7 8.1 2.7 8.1 3.1 7.1 7.8 9.1 7.8 9.1 2.3 1.2 4.9 1.9 7.5 2 2.5.1 5-.4 7.2-1.5 2.4-1.2 4.6-3 6.3-5.1 1.1-1.3 2.8-4.5 2.8-4.5 1.9-3.7 3.3-7.6 4.3-11.6.7-2.5 1.2-5 1.6-7.6.2-1.3.4-2.5.5-3.8.2-1.2.2-2.4-.1-3.6-.1-.2-.1-.4-.2-.6-.6-1.5-1.7-2.7-3.1-3.5-1-.7-2.2-1-3.4-1"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__B)",
  d: "M63.5 7.628c-.6 0-1.2.1-1.7.2q1.95 2.85 3.3 6c.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3s-1.4 1.2-2.3 1.5c-.8.3-1.8.5-2.7.5-1.2 0-2.5-.3-3.5-1l-.7 2.7c-1.3 4.4-2.2 6-2.2 6-.5 1.2-1.1 2.3-1.8 3.4-.5.7-1.1 1.4-1.9 1.7-.3.1-.6.1-.9.1q-.45 0-.9-.3c-.5-.4-1-1-1.3-1.6-.4-.7-.7-1.4-1-2.1-.6-1.5-1.6-5.2-1.6-5.2l-1-3.9-1-3.9-.7-2.6c-1.8-6.7-4.4-10-4.4-10-2-2.9-4.9-5-8.2-6.2-3.8-1.4-7.8-.6-7.8-.6-6.3 1.2-9.6 5.5-11 7.6.7.2 1.3.4 1.9.8.8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6.4 3.5 1.1 6.9 2 10.3 2.1-7.1 4.7-10.4 4.7-10.4.3-.4.6-.7 1-.9.2-.1.4-.2.7-.2.4 0 .9.1 1.2.3.1 0 .1.1.2.1.3.3.6.6.9 1 .5 1 1 1.9 1.4 3 .8 2.2 1.5 5 1.5 5l2 8c1.5 5.5 2.7 8.1 2.7 8.1 3.1 7.1 7.8 9.1 7.8 9.1 2.3 1.2 4.9 1.9 7.5 2 2.5.1 5-.4 7.2-1.5 2.4-1.2 4.6-3 6.3-5.1 1.1-1.3 2.8-4.5 2.8-4.5 1.9-3.7 3.3-7.6 4.3-11.6.7-2.5 1.2-5 1.6-7.6.2-1.3.4-2.5.5-3.8.2-1.2.2-2.4-.1-3.6-.1-.2-.1-.4-.2-.6-.6-1.5-1.7-2.7-3.1-3.5-1-.7-2.2-1-3.4-1"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__C)",
  d: "M63.5 7.628c-.6 0-1.2.1-1.7.2q1.95 2.85 3.3 6c.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3s-1.4 1.2-2.3 1.5c-.8.3-1.8.5-2.7.5-1.2 0-2.5-.3-3.5-1l-.7 2.7c-1.3 4.4-2.2 6-2.2 6-.5 1.2-1.1 2.3-1.8 3.4-.5.7-1.1 1.4-1.9 1.7-.3.1-.6.1-.9.1q-.45 0-.9-.3c-.5-.4-1-1-1.3-1.6-.4-.7-.7-1.4-1-2.1-.6-1.5-1.6-5.2-1.6-5.2l-1-3.9-1-3.9-.7-2.6c-1.8-6.7-4.4-10-4.4-10-2-2.9-4.9-5-8.2-6.2-3.8-1.4-7.8-.6-7.8-.6-6.3 1.2-9.6 5.5-11 7.6.7.2 1.3.4 1.9.8.8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6.4 3.5 1.1 6.9 2 10.3 2.1-7.1 4.7-10.4 4.7-10.4.3-.4.6-.7 1-.9.2-.1.4-.2.7-.2.4 0 .9.1 1.2.3.1 0 .1.1.2.1.3.3.6.6.9 1 .5 1 1 1.9 1.4 3 .8 2.2 1.5 5 1.5 5l2 8c1.5 5.5 2.7 8.1 2.7 8.1 3.1 7.1 7.8 9.1 7.8 9.1 2.3 1.2 4.9 1.9 7.5 2 2.5.1 5-.4 7.2-1.5 2.4-1.2 4.6-3 6.3-5.1 1.1-1.3 2.8-4.5 2.8-4.5 1.9-3.7 3.3-7.6 4.3-11.6.7-2.5 1.2-5 1.6-7.6.2-1.3.4-2.5.5-3.8.2-1.2.2-2.4-.1-3.6-.1-.2-.1-.4-.2-.6-.6-1.5-1.7-2.7-3.1-3.5-1-.7-2.2-1-3.4-1"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__D)",
  d: "M63.5 7.628c-.6 0-1.2.1-1.7.2q1.95 2.85 3.3 6c.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3s-1.4 1.2-2.3 1.5c-.8.3-1.8.5-2.7.5-1.2 0-2.5-.3-3.5-1l-.7 2.7c-1.3 4.4-2.2 6-2.2 6-.5 1.2-1.1 2.3-1.8 3.4-.5.7-1.1 1.4-1.9 1.7-.3.1-.6.1-.9.1q-.45 0-.9-.3c-.5-.4-1-1-1.3-1.6-.4-.7-.7-1.4-1-2.1-.6-1.5-1.6-5.2-1.6-5.2l-1-3.9-1-3.9-.7-2.6c-1.8-6.7-4.4-10-4.4-10-2-2.9-4.9-5-8.2-6.2-3.8-1.4-7.8-.6-7.8-.6-6.3 1.2-9.6 5.5-11 7.6.7.2 1.3.4 1.9.8.8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6.4 3.5 1.1 6.9 2 10.3 2.1-7.1 4.7-10.4 4.7-10.4.3-.4.6-.7 1-.9.2-.1.4-.2.7-.2.4 0 .9.1 1.2.3.1 0 .1.1.2.1.3.3.6.6.9 1 .5 1 1 1.9 1.4 3 .8 2.2 1.5 5 1.5 5l2 8c1.5 5.5 2.7 8.1 2.7 8.1 3.1 7.1 7.8 9.1 7.8 9.1 2.3 1.2 4.9 1.9 7.5 2 2.5.1 5-.4 7.2-1.5 2.4-1.2 4.6-3 6.3-5.1 1.1-1.3 2.8-4.5 2.8-4.5 1.9-3.7 3.3-7.6 4.3-11.6.7-2.5 1.2-5 1.6-7.6.2-1.3.4-2.5.5-3.8.2-1.2.2-2.4-.1-3.6-.1-.2-.1-.4-.2-.6-.6-1.5-1.7-2.7-3.1-3.5-1-.7-2.2-1-3.4-1"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__E)",
  d: "M63.5 7.628c-.6 0-1.2.1-1.7.2q1.95 2.85 3.3 6c.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3s-1.4 1.2-2.3 1.5c-.8.3-1.8.5-2.7.5-1.2 0-2.5-.3-3.5-1l-.7 2.7c-1.3 4.4-2.2 6-2.2 6-.5 1.2-1.1 2.3-1.8 3.4-.5.7-1.1 1.4-1.9 1.7-.3.1-.6.1-.9.1q-.45 0-.9-.3c-.5-.4-1-1-1.3-1.6-.4-.7-.7-1.4-1-2.1-.6-1.5-1.6-5.2-1.6-5.2l-1-3.9-1-3.9-.7-2.6c-1.8-6.7-4.4-10-4.4-10-2-2.9-4.9-5-8.2-6.2-3.8-1.4-7.8-.6-7.8-.6-6.3 1.2-9.6 5.5-11 7.6.7.2 1.3.4 1.9.8.8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6.4 3.5 1.1 6.9 2 10.3 2.1-7.1 4.7-10.4 4.7-10.4.3-.4.6-.7 1-.9.2-.1.4-.2.7-.2.4 0 .9.1 1.2.3.1 0 .1.1.2.1.3.3.6.6.9 1 .5 1 1 1.9 1.4 3 .8 2.2 1.5 5 1.5 5l2 8c1.5 5.5 2.7 8.1 2.7 8.1 3.1 7.1 7.8 9.1 7.8 9.1 2.3 1.2 4.9 1.9 7.5 2 2.5.1 5-.4 7.2-1.5 2.4-1.2 4.6-3 6.3-5.1 1.1-1.3 2.8-4.5 2.8-4.5 1.9-3.7 3.3-7.6 4.3-11.6.7-2.5 1.2-5 1.6-7.6.2-1.3.4-2.5.5-3.8.2-1.2.2-2.4-.1-3.6-.1-.2-.1-.4-.2-.6-.6-1.5-1.7-2.7-3.1-3.5-1-.7-2.2-1-3.4-1"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__F)",
  d: "M63.5 7.628c-.6 0-1.2.1-1.7.2q1.95 2.85 3.3 6c.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3s-1.4 1.2-2.3 1.5c-.8.3-1.8.5-2.7.5-1.2 0-2.5-.3-3.5-1l-.7 2.7c-1.3 4.4-2.2 6-2.2 6-.5 1.2-1.1 2.3-1.8 3.4-.5.7-1.1 1.4-1.9 1.7-.3.1-.6.1-.9.1q-.45 0-.9-.3c-.5-.4-1-1-1.3-1.6-.4-.7-.7-1.4-1-2.1-.6-1.5-1.6-5.2-1.6-5.2l-1-3.9-1-3.9-.7-2.6c-1.8-6.7-4.4-10-4.4-10-2-2.9-4.9-5-8.2-6.2-3.8-1.4-7.8-.6-7.8-.6-6.3 1.2-9.6 5.5-11 7.6.7.2 1.3.4 1.9.8.8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6.4 3.5 1.1 6.9 2 10.3 2.1-7.1 4.7-10.4 4.7-10.4.3-.4.6-.7 1-.9.2-.1.4-.2.7-.2.4 0 .9.1 1.2.3.1 0 .1.1.2.1.3.3.6.6.9 1 .5 1 1 1.9 1.4 3 .8 2.2 1.5 5 1.5 5l2 8c1.5 5.5 2.7 8.1 2.7 8.1 3.1 7.1 7.8 9.1 7.8 9.1 2.3 1.2 4.9 1.9 7.5 2 2.5.1 5-.4 7.2-1.5 2.4-1.2 4.6-3 6.3-5.1 1.1-1.3 2.8-4.5 2.8-4.5 1.9-3.7 3.3-7.6 4.3-11.6.7-2.5 1.2-5 1.6-7.6.2-1.3.4-2.5.5-3.8.2-1.2.2-2.4-.1-3.6-.1-.2-.1-.4-.2-.6-.6-1.5-1.7-2.7-3.1-3.5-1-.7-2.2-1-3.4-1"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__G)",
  d: "M63.5 7.628c-.6 0-1.2.1-1.7.2q1.95 2.85 3.3 6c.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3s-1.4 1.2-2.3 1.5c-.8.3-1.8.5-2.7.5-1.2 0-2.5-.3-3.5-1l-.7 2.7c-1.3 4.4-2.2 6-2.2 6-.5 1.2-1.1 2.3-1.8 3.4-.5.7-1.1 1.4-1.9 1.7-.3.1-.6.1-.9.1q-.45 0-.9-.3c-.5-.4-1-1-1.3-1.6-.4-.7-.7-1.4-1-2.1-.6-1.5-1.6-5.2-1.6-5.2l-1-3.9-1-3.9-.7-2.6c-1.8-6.7-4.4-10-4.4-10-2-2.9-4.9-5-8.2-6.2-3.8-1.4-7.8-.6-7.8-.6-6.3 1.2-9.6 5.5-11 7.6.7.2 1.3.4 1.9.8.8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6.4 3.5 1.1 6.9 2 10.3 2.1-7.1 4.7-10.4 4.7-10.4.3-.4.6-.7 1-.9.2-.1.4-.2.7-.2.4 0 .9.1 1.2.3.1 0 .1.1.2.1.3.3.6.6.9 1 .5 1 1 1.9 1.4 3 .8 2.2 1.5 5 1.5 5l2 8c1.5 5.5 2.7 8.1 2.7 8.1 3.1 7.1 7.8 9.1 7.8 9.1 2.3 1.2 4.9 1.9 7.5 2 2.5.1 5-.4 7.2-1.5 2.4-1.2 4.6-3 6.3-5.1 1.1-1.3 2.8-4.5 2.8-4.5 1.9-3.7 3.3-7.6 4.3-11.6.7-2.5 1.2-5 1.6-7.6.2-1.3.4-2.5.5-3.8.2-1.2.2-2.4-.1-3.6-.1-.2-.1-.4-.2-.6-.6-1.5-1.7-2.7-3.1-3.5-1-.7-2.2-1-3.4-1"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__H)",
  d: "M63.5 7.628c-.6 0-1.2.1-1.7.2q1.95 2.85 3.3 6c.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3s-1.4 1.2-2.3 1.5c-.8.3-1.8.5-2.7.5-1.2 0-2.5-.3-3.5-1l-.7 2.7c-1.3 4.4-2.2 6-2.2 6-.5 1.2-1.1 2.3-1.8 3.4-.5.7-1.1 1.4-1.9 1.7-.3.1-.6.1-.9.1q-.45 0-.9-.3c-.5-.4-1-1-1.3-1.6-.4-.7-.7-1.4-1-2.1-.6-1.5-1.6-5.2-1.6-5.2l-1-3.9-1-3.9-.7-2.6c-1.8-6.7-4.4-10-4.4-10-2-2.9-4.9-5-8.2-6.2-3.8-1.4-7.8-.6-7.8-.6-6.3 1.2-9.6 5.5-11 7.6.7.2 1.3.4 1.9.8.8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6.4 3.5 1.1 6.9 2 10.3 2.1-7.1 4.7-10.4 4.7-10.4.3-.4.6-.7 1-.9.2-.1.4-.2.7-.2.4 0 .9.1 1.2.3.1 0 .1.1.2.1.3.3.6.6.9 1 .5 1 1 1.9 1.4 3 .8 2.2 1.5 5 1.5 5l2 8c1.5 5.5 2.7 8.1 2.7 8.1 3.1 7.1 7.8 9.1 7.8 9.1 2.3 1.2 4.9 1.9 7.5 2 2.5.1 5-.4 7.2-1.5 2.4-1.2 4.6-3 6.3-5.1 1.1-1.3 2.8-4.5 2.8-4.5 1.9-3.7 3.3-7.6 4.3-11.6.7-2.5 1.2-5 1.6-7.6.2-1.3.4-2.5.5-3.8.2-1.2.2-2.4-.1-3.6-.1-.2-.1-.4-.2-.6-.6-1.5-1.7-2.7-3.1-3.5-1-.7-2.2-1-3.4-1"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#webExSmall_svg__I)",
  d: "M63.5 7.628c-.6 0-1.2.1-1.7.2q1.95 2.85 3.3 6c.4.9.6 1.9.6 2.9 0 .9-.2 1.8-.5 2.7-.4.8-.9 1.6-1.5 2.3s-1.4 1.2-2.3 1.5c-.8.3-1.8.5-2.7.5-1.2 0-2.5-.3-3.5-1l-.7 2.7c-1.3 4.4-2.2 6-2.2 6-.5 1.2-1.1 2.3-1.8 3.4-.5.7-1.1 1.4-1.9 1.7-.3.1-.6.1-.9.1q-.45 0-.9-.3c-.5-.4-1-1-1.3-1.6-.4-.7-.7-1.4-1-2.1-.6-1.5-1.6-5.2-1.6-5.2l-1-3.9-1-3.9-.7-2.6c-1.8-6.7-4.4-10-4.4-10-2-2.9-4.9-5-8.2-6.2-3.8-1.4-7.8-.6-7.8-.6-6.3 1.2-9.6 5.5-11 7.6.7.2 1.3.4 1.9.8.8.5 1.5 1.1 2 1.8.9 1.3 1.2 3 1.3 4.6.4 3.5 1.1 6.9 2 10.3 2.1-7.1 4.7-10.4 4.7-10.4.3-.4.6-.7 1-.9.2-.1.4-.2.7-.2.4 0 .9.1 1.2.3.1 0 .1.1.2.1.3.3.6.6.9 1 .5 1 1 1.9 1.4 3 .8 2.2 1.5 5 1.5 5l2 8c1.5 5.5 2.7 8.1 2.7 8.1 3.1 7.1 7.8 9.1 7.8 9.1 2.3 1.2 4.9 1.9 7.5 2 2.5.1 5-.4 7.2-1.5 2.4-1.2 4.6-3 6.3-5.1 1.1-1.3 2.8-4.5 2.8-4.5 1.9-3.7 3.3-7.6 4.3-11.6.7-2.5 1.2-5 1.6-7.6.2-1.3.4-2.5.5-3.8.2-1.2.2-2.4-.1-3.6-.1-.2-.1-.4-.2-.6-.6-1.5-1.7-2.7-3.1-3.5-1-.7-2.2-1-3.4-1"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "webExSmall_svg__b",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(74.32 5.962 36.72)scale(26.2008 19.9126)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#227B60"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#227B60",
  stopOpacity: 0.81
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.58,
  stopColor: "#227B60",
  stopOpacity: 0.23
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#227B60",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webExSmall_svg__c",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.35429 17.71376 -13.4606 -.26922 43.614 19.171)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#227B60"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.25,
  stopColor: "#227B60",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#227B60",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.92,
  stopColor: "#227B60",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webExSmall_svg__d",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(88.6 11.187 31.87)scale(16.5156 11.726)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#227B60"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.07,
  stopColor: "#227B60",
  stopOpacity: 0.9
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#227B60",
  stopOpacity: 0.51
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#227B60",
  stopOpacity: 0.23
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#227B60",
  stopOpacity: 0.06
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.92,
  stopColor: "#227B60",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webExSmall_svg__e",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(.3258 13.33122 -9.4652 .23132 43.059 19.167)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#227B60"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#227B60",
  stopOpacity: 0.63
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.92,
  stopColor: "#227B60",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webExSmall_svg__f",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(.2599 10.63242 -6.8048 .16634 43.635 19.906)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#20735A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.15,
  stopColor: "#20745A",
  stopOpacity: 0.93
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.38,
  stopColor: "#21755C",
  stopOpacity: 0.74
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#21785D",
  stopOpacity: 0.43
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#227B60",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webExSmall_svg__g",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(23.8 -28.787 117.715)scale(17.1146 12.836)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#227A61"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#227A61",
  stopOpacity: 0.56
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#227A61",
  stopOpacity: 0.16
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#227A61",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webExSmall_svg__h",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(18.6342 13.18028 -12.0515 17.03835 39.162 -6.184)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3CD9C3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.07,
  stopColor: "#3BD7C1",
  stopOpacity: 0.9
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.41,
  stopColor: "#38CEB9",
  stopOpacity: 0.42
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#36C8B4",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#35C6B2",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webExSmall_svg__i",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(3310.54997 2341.60665 -1643.22119 2323.17663 -37429.2 -50860.8)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3CD9C3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.07,
  stopColor: "#3BD7C1",
  stopOpacity: 0.9
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.41,
  stopColor: "#38CEB9",
  stopOpacity: 0.42
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#36C8B4",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#35C6B2",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webExSmall_svg__j",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(100.972 13.441 32.916)scale(20.1302 24.8754)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#237F66",
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.06,
  stopColor: "#2C8C70",
  stopOpacity: 0.65
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.21,
  stopColor: "#3DA785",
  stopOpacity: 0.37
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#4ABA93",
  stopOpacity: 0.17
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#51C59C",
  stopOpacity: 0.04
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#54C99F",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webExSmall_svg__k",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(16.61797 -20.39017 22.02135 17.94738 37.148 26.983)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#167C8A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#167C8A",
  stopOpacity: 0.93
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#177F8D",
  stopOpacity: 0.43
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#17818F",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#178290",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webExSmall_svg__l",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(21.84201 -13.4688 10.64034 17.25518 35.552 29.6)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.05,
  stopColor: "#177D87"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.11,
  stopColor: "#177E89",
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.21,
  stopColor: "#177F8B",
  stopOpacity: 0.52
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "#17818D",
  stopOpacity: 0.29
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#17818F",
  stopOpacity: 0.13
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#178290",
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#178290",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webExSmall_svg__m",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-9.93706 -11.61878 9.14882 -7.82461 30.223 29.277)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#177F8A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#177F8A",
  stopOpacity: 0.98
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.38,
  stopColor: "#17808C",
  stopOpacity: 0.68
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#17818D",
  stopOpacity: 0.43
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#17818F",
  stopOpacity: 0.24
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#17828F",
  stopOpacity: 0.11
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.86,
  stopColor: "#178290",
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#178290",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webExSmall_svg__n",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-173.11 14.255 16.1)scale(14.3411)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#13656E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.11,
  stopColor: "#13646E",
  stopOpacity: 0.73
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#12646E",
  stopOpacity: 0.41
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#12636E",
  stopOpacity: 0.18
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.55,
  stopColor: "#12636E",
  stopOpacity: 0.05
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#12636E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webExSmall_svg__o",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-119.32 23.58 10.346)scale(10.0292 8.42451)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#146A73"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.24,
  stopColor: "#156F79",
  stopOpacity: 0.79
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#167783",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#167D8A",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#17818E",
  stopOpacity: 0.05
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.95,
  stopColor: "#178290",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webExSmall_svg__p",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-55.992 41.473 -6.745)scale(9.43443 7.47414)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#198E9C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#198E9C",
  stopOpacity: 0.87
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.41,
  stopColor: "#198E9C",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#198E9C",
  stopOpacity: 0.23
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.88,
  stopColor: "#198E9C",
  stopOpacity: 0.06
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#198E9C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webExSmall_svg__w",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-4.76382 31.16774 -20.5707 -3.14412 53.127 23.61)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1A3D9C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#1A3D9C",
  stopOpacity: 0.42
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#1A3D9C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webExSmall_svg__x",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-586.03976 3834.26254 -2067.40118 -315.98757 19187.6 -49513.4)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1A3D9C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#1A3D9C",
  stopOpacity: 0.42
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#1A3D9C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webExSmall_svg__y",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(98.616 30042.467 -17897.427)scale(4619.43 1908.39)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1A3D9C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#1A3D9C",
  stopOpacity: 0.42
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#1A3D9C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webExSmall_svg__z",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(3.3163 27.35924 -19.08957 2.31391 49.189 22.425)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1A3D9C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#1A3D9C",
  stopOpacity: 0.69
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#1A3D9C",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#1A3D9C",
  stopOpacity: 0.18
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.61,
  stopColor: "#1A3D9C",
  stopOpacity: 0.05
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#1A3D9C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webExSmall_svg__A",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(7.01563 25.53954 -17.36688 4.77063 54.16 26.627)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#18388F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.37,
  stopColor: "#193B96",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#1A3D9C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webExSmall_svg__B",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(3.2619 11.87474 -11.28093 3.0988 51.514 33.703)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#18388F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.09,
  stopColor: "#183992",
  stopOpacity: 0.78
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.22,
  stopColor: "#193B96",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#193C98",
  stopOpacity: 0.28
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#1A3C9A",
  stopOpacity: 0.13
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#1A3D9C",
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#1A3D9C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webExSmall_svg__C",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(3.2619 11.87474 -11.28093 3.0988 51.81 35.804)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1A3D9C",
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#1A3D9C",
  stopOpacity: 0.78
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.24,
  stopColor: "#1A3D9C",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#1A3D9C",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#1A3D9C",
  stopOpacity: 0.05
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#1A3D9C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webExSmall_svg__D",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(11.4702 27.0578 -17.95549 7.6116 21.318 28.265)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1A3D9C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#1A3D9C",
  stopOpacity: 0.56
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#1A3D9C",
  stopOpacity: 0.43
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#1A3D9C",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#1A3D9C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webExSmall_svg__E",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(76.103 -4.081 23.228)scale(21.7985 14.3912)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1A3D9C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.06,
  stopColor: "#1A3D9C",
  stopOpacity: 0.88
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.21,
  stopColor: "#1A3D9C",
  stopOpacity: 0.61
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#1A3D9C",
  stopOpacity: 0.39
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#1A3D9C",
  stopOpacity: 0.22
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#1A3D9C",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#1A3D9C",
  stopOpacity: 0.02
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1A3D9C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webExSmall_svg__F",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(76.103 -4.081 23.228)scale(21.7985 14.3912)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1B3E9E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.06,
  stopColor: "#1B3E9E",
  stopOpacity: 0.87
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.21,
  stopColor: "#1B3E9D",
  stopOpacity: 0.61
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#1A3D9D",
  stopOpacity: 0.39
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.52,
  stopColor: "#1A3D9C",
  stopOpacity: 0.22
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#1A3D9C",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#1A3D9C",
  stopOpacity: 0.02
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1A3D9C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webExSmall_svg__G",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(4.00542 16.18865 -10.68763 2.64435 20.288 19.48)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#183991"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.03,
  stopColor: "#183992",
  stopOpacity: 0.95
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#193A95",
  stopOpacity: 0.66
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#193B97",
  stopOpacity: 0.42
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#1A3C99",
  stopOpacity: 0.24
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#1A3D9B",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#1A3D9C",
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1A3D9C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "webExSmall_svg__H",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(.6581 13.16146 -11.58603 .57932 23.228 21.173)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#2453D6",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2,
  stopColor: "#2453D6",
  stopOpacity: 0.49
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.52,
  stopColor: "#2453D6",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  stopColor: "#2453D6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "webExSmall_svg__a",
  x1: 3.17,
  x2: 57.989,
  y1: 34.099,
  y2: 11.94,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#1CBBF3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#1F99A5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#209CA6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#24A4AA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.57,
  stopColor: "#2BB3B0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#30BDB4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#38BA90"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#60F05A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "webExSmall_svg__q",
  x1: 6.696,
  x2: 30.885,
  y1: -1.118,
  y2: 21.267,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#2BF9FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#29F9FF",
  stopOpacity: 0.64
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#27FAFF",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#26FAFF",
  stopOpacity: 0.08
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#26FAFF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "webExSmall_svg__r",
  x1: -6.998,
  x2: 21.255,
  y1: 35.408,
  y2: 27.398,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#26FAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.06,
  stopColor: "#26FAFF",
  stopOpacity: 0.88
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.24,
  stopColor: "#26FAFF",
  stopOpacity: 0.51
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#26FAFF",
  stopOpacity: 0.23
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#26FAFF",
  stopOpacity: 0.06
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.55,
  stopColor: "#26FAFF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "webExSmall_svg__s",
  x1: 0.487,
  x2: 32.328,
  y1: 34.426,
  y2: 23.077,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#21DEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#21DEFF",
  stopOpacity: 0.88
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.17,
  stopColor: "#21DEFF",
  stopOpacity: 0.51
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#21DEFF",
  stopOpacity: 0.23
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#21DEFF",
  stopOpacity: 0.06
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.38,
  stopColor: "#21DEFF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "webExSmall_svg__t",
  x1: 30.743,
  x2: 48.553,
  y1: 18.001,
  y2: 47.05,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#21DEFF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#21DEFF",
  stopOpacity: 0.06
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  stopColor: "#21DEFF",
  stopOpacity: 0.23
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#21DEFF",
  stopOpacity: 0.51
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.96,
  stopColor: "#21DEFF",
  stopOpacity: 0.88
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#21DEFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "webExSmall_svg__u",
  x1: 50.563,
  x2: 47.764,
  y1: 28.854,
  y2: 15.19,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#44B044"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.11,
  stopColor: "#44B044",
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#44B044",
  stopOpacity: 0.52
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#44B044",
  stopOpacity: 0.29
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.58,
  stopColor: "#44B044",
  stopOpacity: 0.13
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#44B044",
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#44B044",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "webExSmall_svg__v",
  x1: 11.488,
  x2: 70.446,
  y1: 14.674,
  y2: 34.192,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3066FB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.38,
  stopColor: "#2F64F7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#2857D9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3C7EFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "webExSmall_svg__I",
  x1: 49.779,
  x2: 34.887,
  y1: -9.388,
  y2: 27.422,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3774FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.05,
  stopColor: "#3774FF",
  stopOpacity: 0.91
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#3774FF",
  stopOpacity: 0.66
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "#3774FF",
  stopOpacity: 0.28
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#3774FF",
  stopOpacity: 0
})))));
export { SvgWebExSmall as ReactComponent };
export default __webpack_public_path__ + "static/media/webExSmall.f96ca366.svg";